/**
 * Capacidades del usuario.
 *
 * Se pregunta siempre por permiso y nunca por rol. El rol es un paquete de
 * permisos que se redefine en el servidor (RolesSeeder); si la interfaz
 * comprueba `roles.includes('admin')`, mover una capacidad de un rol a otro
 * obliga a tocar el frontend y, mientras tanto, la pantalla y la API discrepan.
 * Eso es justo lo que pasaba con el acceso al panel: la cabecera lo ofrecía a
 * quien tuviera el permiso `show_admin` —que también tenía la modelo— y el
 * layout lo negaba por rol, así que el enlace expulsaba a quien lo pulsaba.
 */

/** ¿Tiene alguno de estos permisos? */
export const can = (user, ...permissions) =>
  permissions.some((permission) => Boolean(user?.permissions?.includes(permission)));

/** ¿Los tiene todos? */
export const canAll = (user, ...permissions) =>
  permissions.every((permission) => Boolean(user?.permissions?.includes(permission)));

/** Permisos que dan acceso a alguna pantalla del panel de administración. */
export const ADMIN_PERMISSIONS = [
  'view_models',
  'manage_models',
  'view_clients',
  'view_all_users',
  'manage_users',
  'manage_gallery',
];

export const canEnterAdmin = (user) => can(user, ...ADMIN_PERMISSIONS);

/** Permisos que dan acceso al panel de la modelo. */
export const PANEL_PERMISSIONS = ['edit_own_profile', 'view_own_supporters'];

export const canEnterPanel = (user) => can(user, ...PANEL_PERMISSIONS);

/**
 * A dónde llevar a alguien que acaba de entrar, o que ha pulsado "mi cuenta".
 *
 * Cada rol aterriza donde puede trabajar en vez de en una pantalla que le van
 * a negar: antes todo el mundo caía en /live y la modelo tenía que descubrir
 * por su cuenta que su perfil se editaba en otro sitio.
 */
export const homeFor = (user) => {
  if (!user) return '/';
  if (canEnterAdmin(user)) return '/admin';
  if (canEnterPanel(user)) return '/panel';
  return '/live';
};
